import { dateTimestampProvider } from './scheduler/dateTimestampProvider';
var Scheduler = (function () {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = dateTimestampProvider.now;
    return Scheduler;
}());
export { Scheduler };
//# sourceMappingURL=Scheduler.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/dist/esm5/internal/Scheduler.js
// module id = 421
// module chunks = 0